import InformationBar from './InformationBar';
import NavigationBar from './NavigationBar';
import TabCategory from './TabCategory';
import QuickRedemption from './QuickRedemption';
import Icon from './QuickAccess';
import FloorPoster from './FloorPoster';
import ModalLayer from './ModalLayer';
import SinglePost from './SinglePost';
import RichTextBlockProd from './RichTextBlockProd';
import NewToolbar from './NewToolbar';

const data = {
  InformationBar,
  NavigationBar,
  Icon,
  TabCategory,
  QuickRedemption,
  FloorPoster,
  ModalLayer,
  SinglePost,
  RichTextBlockProd,
  NewToolbar,
};

export default data;
